import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-62e6644c")

_pushScopeId("data-v-62e6644c")
const _hoisted_1 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "8",
  rx: ".25rem",
  ry: ".25rem",
  width: "56",
  height: "56"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("rect", {
  x: "70",
  y: "10",
  rx: ".25rem",
  ry: ".25rem",
  width: "140",
  height: "22"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("rect", {
  x: "70",
  y: "44",
  rx: ".25rem",
  ry: ".25rem",
  width: "260",
  height: "17"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_content_loader = _resolveComponent("content-loader")!

  return (_openBlock(), _createBlock(_component_content_loader, {
    class: "tableOpacity",
    width: "100%",
    height: "75",
    speed: 2,
    primaryColor: "#929292",
    secondaryColor: "#cccccc"
  }, {
    default: _withId(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }))
})